import { PropositionFiltersDto } from "@dune/types";

export const propositionsQueryKeys = {
	all: ["propositions"] as const,
	lists: () => [...propositionsQueryKeys.all, "lists"] as const,
	list: (filters?: PropositionFiltersDto) =>
		[...propositionsQueryKeys.lists(), filters] as const,
	details: () => [...propositionsQueryKeys.all, "details"] as const,
	detail: (id: number) => [...propositionsQueryKeys.details(), id] as const,
	documents: (propositionId: number) =>
		[...propositionsQueryKeys.all, "documents", propositionId] as const,
	files: (propositionId: number, type?: string) =>
		[...propositionsQueryKeys.all, "files", propositionId, type] as const,
	activeEnvelope: (propositionId: number) =>
		[...propositionsQueryKeys.all, "active-envelope", propositionId] as const,
	communications: (
		propositionId: number,
		params?: {
			page?: number;
			limit?: number;
			sortBy?: string;
			sortOrder?: "asc" | "desc";
		},
	) =>
		[
			...propositionsQueryKeys.all,
			"communications",
			propositionId,
			params,
		] as const,
	tasks: (propositionId: number) =>
		[...propositionsQueryKeys.all, "tasks", propositionId] as const,
	unprocessedCommunicationsCount: (propositionId: number) =>
		[
			...propositionsQueryKeys.all,
			"communications",
			propositionId,
			"unprocessed-count",
		] as const,
	byConstructionSite: (constructionSiteId: number) =>
		[
			...propositionsQueryKeys.all,
			"by-construction-site",
			constructionSiteId,
		] as const,
	byBroker: (brokerId: number) =>
		[...propositionsQueryKeys.all, "by-broker", brokerId] as const,
	counts: () => [...propositionsQueryKeys.all, "counts"] as const,
	templateData: (propositionId: number) =>
		[...propositionsQueryKeys.all, "template-data", propositionId] as const,
} as const;
